import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormGroup, Label, Input, FormFeedback, Row, Col } from "reactstrap";
import { metadataService } from "../../_services/metadata.service";
//import { connect } from "react-redux";
//import { Alert } from 'reactstrap';
//import validator from 'validator';

export class DatePickerCombo extends Component {
  constructor(props) {
    super(props);
      if (props.value) {
          var dateValue = new Date(props.value);
          this.state = {
              visited: false,
              hasFocus: false,
              dateValue,
              monthValue: this.formatNumber(dateValue.getUTCMonth() + 1),
              dayValue: this.formatNumber(dateValue.getUTCDate()),
              yearValue: dateValue.getUTCFullYear(),
          };
      }
      else {
          this.state = {
              dateValue: null,
              visited: false,
              hasFocus: false,
              monthValue: '',
              dayValue: '',
              yearValue: '',
          };
      }
    //this.handleOnBlur = this.handleOnBlur.bind(this);
    this.handleDayChange = this.handleDayChange.bind(this);
    this.handleMonthChange = this.handleMonthChange.bind(this);
    this.handleYearChange = this.handleYearChange.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.handleOnFocus = this.handleOnFocus.bind(this);
  }


  handleMonthChange(e){
    const newMonth = e.target.value; 
    const selectedYear = this.state.yearValue; 
    const dayValue = this.calcNewDayValue(newMonth, selectedYear);
    
    this.setState({
        monthValue: e.target.value, 
        dayValue : dayValue
    })
    this.handleValueChange({...this.state, monthValue: e.target.value, dayValue: dayValue})
  }

  handleDayChange(e){
    this.setState({
        dayValue: e.target.value
    })
    this.handleValueChange({...this.state, dayValue: e.target.value})
  }

  calcNewDayValue(month, year){
    const daysInMonth = this.getNumberOfDaysInMonth(month, year)
    if(this.state.dayValue && parseInt(this.state.dayValue, 10) <= daysInMonth){
        return this.state.dayValue; 
    }
    return '';
    
  }
  handleYearChange(e){
    const selectedMonth = this.state.monthValue; 
    const newYear = e.target.value; 
    const dayValue = this.calcNewDayValue(selectedMonth, newYear);
    this.setState({
        yearValue: e.target.value, 
        dayValue : dayValue
    })
    this.handleValueChange({...this.state, yearValue: newYear, dayValue})
  }
  handleValueChange(newVal){
    let dateValue = '';
    if(newVal.monthValue && newVal.dayValue && newVal.yearValue){
      dateValue = newVal.yearValue + "-" + newVal.monthValue + "-" + newVal.dayValue; 
    }
        //let dateValue = new Date(this.state.yearValue + '/' + this.state.monthValue + "/" + this.state.dayValue)
      this.props.onChange(
          {
              target:{
                  name: this.props.name, 
                  value : dateValue
              }
          }); 
    
  }

  getMonths() {
    let monthList = []; 
    for(let i = 1; i <= 12; i++){
        monthList.push(this.formatNumber(i))
    }
    return monthList; 
  }

  formatNumber(num){
      return num < 10 ? '0' + num : num; 
  }

  getYears() {
    let years = [];
    const thisYear = new Date(Date.now()).getFullYear();
    for (let y = thisYear - 18; y >= thisYear - 120; y--) {
      years.push(y);
    }
    return years;
  }

  isLeapYear(year) {
    if (year) {
      const yearNum = parseInt(year, 10);
      if (yearNum % 4 === 0) {
        if (yearNum % 100 === 0 && yearNum % 1000 !== 0) {
          return false;
        }
        return true;
      }
    }
    return false;
  }
  getNumberOfDaysInMonth(month, year){
    
    switch (parseInt(month, 10)) {
      case 1:
      case 3:
      case 5:
      case 7:
      case 8:
      case 10:
      case 12:
        return 31;
      case 2:
        return this.isLeapYear(year) ?  29 : 28;
      default:
        return 30;
        
    }
  }
  getDays(month, year) {
    const numDays = this.getNumberOfDaysInMonth(month, year);
    let dayList = [];
    for (let d = 1; d <= numDays; d++) {
      dayList.push(this.formatNumber(d));
    }
    return dayList;
  }
  handleOnBlur(){
    this.setState({visited : true, hasFocus: false})
  }
  handleOnFocus(){
    this.setState({hasFocus : true})
  }


  render() {
    const fieldLabel = this.props.label ? this.props.label : metadataService.getFieldNameLabel(this.props.name)
    let monthValue = this.state.monthValue; 
    let dayValue = this.state.dayValue; 
    let yearValue = this.state.yearValue; 
    let hasError = false; 
    let errorMessage = ''; 
    if(this.props.value){
        const dateValue = new Date(this.props.value); 
        if(dateValue.getUTCMonth()){
            monthValue = this.formatNumber(dateValue.getUTCMonth() + 1); 
            dayValue = this.formatNumber(dateValue.getUTCDate());
            yearValue = dateValue.getUTCFullYear();
        }
    }
    if(this.props.fieldErrors){
      let fieldError = this.props.fieldErrors.find(e => e.fieldName === this.props.name); 
      if(fieldError){
          hasError = true; 
          errorMessage = metadataService.getMessage(fieldError.messageName, fieldLabel)
      }
  }
  else if (this.props.isRequired && this.state.visited && !this.state.hasFocus){
      hasError = !this.props.value; 
      errorMessage = metadataService.getMessage('RequiredFieldNotSupplied', fieldLabel)

  }
  if(!hasError){
    errorMessage = null; 
  }
    
    return (
      <FormGroup hasError={this.hasError} >      
          <Label for={this.props.name} hidden={!this.props.showLabel} className={this.props.isRequired && !this.props.disabled ? "required" : ""}>
            {fieldLabel}
          </Label>
        <Row>
          <Col
            xs={{ size: 3, offset: 1 }}
            sm={{size: 2, offset: 2}}
            style={{ paddingLeft: "0px", paddingRight: "2px" }}
          >
            <Input
              type="select"
              id={this.props.name + "_mm_id"}
              invalid={hasError && !this.state.monthValue}
              name={this.props.name}
              value={monthValue}
              onBlur={this.handleOnBlur}
              onFocus={this.handleOnFocus}
              disabled={this.props.disabled}
              onChange={this.handleMonthChange}
              className={this.props.maskOnBlur && !this.state.hasFocus && monthValue ? "security-mask" : ""}
              style={{padding: 'unset'}}
            >
              <option value={''}>{"-MM-"}</option>
              {this.getMonths().map(function(option) {
                return (
                  <option value={option} key={"mm_" + option}>
                    {option}
                  </option>
                );
              })}
            </Input>
          </Col>
          <Col xs="3" 
            sm="2"
            style={{ paddingLeft: "0px", paddingRight: "2px" }}>
            <Input
              type="select"
              id={this.props.name + "_dd_id"}
              invalid={hasError && !this.state.dayValue}
              name={this.props.name}
              value={dayValue}
              onBlur={this.handleOnBlur}
              onFocus={this.handleOnFocus}
              disabled={this.props.disabled}
              onChange={this.handleDayChange}
              className={this.props.maskOnBlur && !this.state.hasFocus && dayValue ? "security-mask" : ""}
              style={{padding: 'unset'}}
            >
              <option value="">{"-DD-"}</option>
              {this.getDays(monthValue, yearValue).map(function(option) {
                return (
                  <option value={option} key={"dd_" + option}>
                    {option}
                  </option>
                );
              })}
            </Input>
          </Col>
          <Col xs="4" sm="3"
            style={{ paddingLeft: "0px", paddingRight: "2px" }}>
            <Input
              type="select"
              id={this.props.name + "_yyy_id"}
              invalid={hasError && !this.state.yearValue}
              name={this.props.name}
              value={yearValue}
              onBlur={this.handleOnBlur}
              onFocus={this.handleOnFocus}
              disabled={this.props.disabled}
              onChange={this.handleYearChange}
              className={this.props.maskOnBlur && !this.state.hasFocus && yearValue ? "security-mask" : ""}
              style={{padding: 'unset'}}
            >
              <option value="">{"-YYYY-"}</option>
              {this.getYears().map(function(option) {
                return (
                  <option value={option} key={"yyyy_" + option}>
                    {option}
                  </option>
                );
              })}
            </Input>
          </Col>
        </Row>
        {hasError &&(<FormFeedback style={{display:'block'}}>{errorMessage}</FormFeedback> )}
        </FormGroup>
    );
  }
}
DatePickerCombo.propTypes = {
    name: PropTypes.string.isRequired,
    label:PropTypes.string, 
    showLabel: PropTypes.bool, 
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string, 
    fieldErrors: PropTypes.array, 
    helpText:PropTypes.string,  
    isRequired: PropTypes.bool,
    maskOnBlur: PropTypes.bool,
    disabled: PropTypes.bool
}
DatePickerCombo.defaultProps = {
    showLabel:true, 
    isRequired: true,
    maskOnBlur: false,
    disabled: false
}


// WEBPACK FOOTER //
// ./src/components/editors/DatePickerCombo.jsx